export default {
    edit: "編輯",
    location: "地點 + 條款和條件",
    filter: "篩選"
}
